
import { DidNotPurchaseReason } from "@/models/company-did-not-purchase-reason";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	props: {
		label: String,
		fancy: Boolean,
		value: Array as ()=>number[],
		includeMisc: Boolean,
		includeUnkown: Boolean
	},
	computed: {
		items():ISelectItem<DidNotPurchaseReason>[] {
			let result = [
				{
					text: "Te duur",
					value: DidNotPurchaseReason.EXPENSIVE
				},
				{
					text: "Te moeilijk",
					value: DidNotPurchaseReason.DIFFICULT
				},
				{
					text: "Niet genoeg functionaliteit",
					value: DidNotPurchaseReason.NOT_ENOUGH_FUNCTIONALITY
				},
				{
					text: "School",
					value: DidNotPurchaseReason.SCHOOL
				},
				{
					text: "Liever niet vermeld",
					value: DidNotPurchaseReason.PREFERED_NOT_TO_SAY
				}
			];
			if (this.includeMisc) {
				result.push({
					text: "Andere",
					value: DidNotPurchaseReason.MISC
				});
			}
			if (this.includeUnkown) {
				result = [
					{
						text: "Niet ingevuld",
						value: DidNotPurchaseReason.UNKOWN
					},
					...result
				];
			}
			return result;
		}
	}
});
